import { Box, Stack } from "@mui/material";
import palette from "theme/palette";
import ScopeChipsRow from "../ScopeChipsRow";
import { ScopeGroup } from "../types";
import SectionLabel from "./SectionLabel";

interface ScopeSectionProps {
  scopeGroups: ScopeGroup[];
}

const ScopeSection = ({ scopeGroups }: ScopeSectionProps) => {
  return (
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <SectionLabel>Области генерации</SectionLabel>
      <Box
        sx={{
          p: 1.25,
          borderRadius: 1.5,
          border: `1px solid ${palette.divider}`,
          backgroundColor: "bgSwitch",
        }}>
        <Stack spacing={0.75}>
          {scopeGroups.map((group) => (
            <ScopeChipsRow
              key={group.id}
              group={group}
            />
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default ScopeSection;
